"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiChooserState = void 0;
var tslib_1 = require("tslib");
var input_state_1 = require("../../components/input/input.state");
var MultiChooserState = /** @class */ (function (_super) {
    tslib_1.__extends(MultiChooserState, _super);
    function MultiChooserState(label) {
        var _this = _super.call(this, label) || this;
        _this.readOnly = true;
        return _this;
    }
    Object.defineProperty(MultiChooserState.prototype, "groups", {
        get: function () {
            return this._groups;
        },
        set: function (value) {
            this._groups = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiChooserState.prototype, "displayValue", {
        get: function () {
            return this._displayValue;
        },
        set: function (value) {
            this._displayValue = value;
        },
        enumerable: false,
        configurable: true
    });
    MultiChooserState.prototype.getAllOptions = function () {
        var allOptions = [];
        //we only keep the last selected node. If intermediate nodes are important, this function needs to be overwritten (see NestedListChooserState)
        for (var _i = 0, _a = this.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            for (var _b = 0, _c = group.items; _b < _c.length; _b++) {
                var item = _c[_b];
                allOptions.push([item]);
            }
        }
        return allOptions;
    };
    return MultiChooserState;
}(input_state_1.InputState));
exports.MultiChooserState = MultiChooserState;
//# sourceMappingURL=multi.list.chooser.state.js.map